









import { Watch, Prop, Component, Vue } from "vue-property-decorator";
import {
  Company,
  Office,
  deleteCompany,
  getOurCompanies
} from "@/api/company-api";
import saveCompany from "@/helpers/saveCompany";
import TaskType from "@/entities/task-type";
import CompanyEdit from "@/templates/CompanyEdit.vue";

@Component({
  components: {
    CompanyEdit
  }
})
export default class OfficeEditPage extends Vue {
  @Prop({ required: true }) id!: string;

  company: Company | null = null;
  office: Office | null = null;

  async ok() {
    if (!this.company || !this.office) return;
    try {
      await saveCompany(this.company, this.office);
      this.$store.dispatch("setSettlementMonth", this.company.settlementMonth);
      this.goShowPage();
    } catch (e) {
      alert(e);
    }
  }

  cancel() {
    this.goShowPage();
  }

  async remove() {
    if (!this.company) return;
    await deleteCompany(this.company.companyId);
    this.goListPage();
  }

  private companies: Company[] = [];

  private created() {
    this.$store.dispatch("tasktype/init");
    this.initCompanies();
  }

  private async initCompanies() {
    this.companies = await getOurCompanies();
    this.selectCompany();
  }

  @Watch("id")
  private selectCompany() {
    const c = this.companies.find(c => String(c.companyId) === this.id);
    if (c) {
      this.company = { ...c };
      this.office = { ...c.office };
    } else {
      this.company = null;
      this.office = null;
    }
  }

  private goListPage() {
    this.$router.push({ name: "office-list" });
  }

  private goShowPage() {
    const params = { id: this.id };
    this.$router.push({ name: "office-show", params });
  }

  get tasktypes(): TaskType[] {
    return this.$store.getters["tasktype/all"];
  }
}
